/**
 * Micheals Infrastructure Advisory - REFERENCE LIBRARY GATEWAY
 * ROLE: Redirect to Architectural Digest for client design inspiration
 * VERSION: 3.3.5
 */

import React from 'react';
import { ExternalLink, BookOpen } from 'lucide-react';

const ReferenceLibraryLink = () => {
  return (
    <div className="w-full max-w-md">
      <div className="bg-stone-50 border border-stone-200 p-6 rounded-2xl">
        <div className="flex items-center gap-3 mb-4">
          <div className="p-2 bg-stone-200 rounded-lg text-stone-900">
            <BookOpen size={20} />
          </div>
          <div>
            <h3 className="text-sm font-bold uppercase tracking-widest text-stone-900">
              Design References
            </h3>
            <p className="text-[10px] text-stone-500 uppercase">
              Curated architectural inspiration
            </p>
          </div>
        </div>

        <a 
          href="https://www.architecturaldigest.com/" 
          target="_blank" 
          rel="noopener noreferrer"
          className="flex items-center justify-between w-full p-4 bg-stone-900 text-white rounded-xl hover:bg-amber-700 transition-all group"
        >
          <span className="text-sm font-medium">Browse Inspiration Library</span>
          <ExternalLink size={16} className="group-hover:translate-x-1 transition-transform" />
        </a>
        
        <p className="text-[9px] text-stone-400 mt-4 uppercase tracking-tighter text-center">
          External reference provided for design brief alignment.
        </p>
      </div>
    </div>
  );
};

export default ReferenceLibraryLink;